import { format } from "date-fns";
import {
  FaArrowDown,
  FaArrowUp,
  FaClock,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

export const TransactionCard = ({ payment }) => {
  // Normalize data
  const isDeposit = payment.type === "Deposite" || payment.type === "Deposit";
  const status = payment.status ? payment.status.toLowerCase() : "pending";

  // Status Colors
  const getStatusColor = (s) => {
    switch (s) {
      case "success":
      case "completed":
        return "text-green-500 bg-green-50";
      case "pending":
        return "text-yellow-600 bg-yellow-50";
      case "failed":
        return "text-red-500 bg-red-50";
      default:
        return "text-gray-500 bg-gray-50";
    }
  };

  return (
    <div className="group flex items-center shadow rounded-xl justify-between p-4 bg-white hover:bg-gray-50 border-b  transition-colors duration-200 last:border-0">
      {/* Left: Icon & Details */}
      <div className="flex items-center gap-4">
        {/* Dynamic Icon Box */}
        <div
          className={`
          w-10 h-10 rounded-full flex items-center justify-center text-lg shadow-sm
          ${
            isDeposit
              ? "bg-green-100 text-green-600"
              : "bg-red-100 text-red-600"
          }
        `}
        >
          {isDeposit ? (
            <FaArrowDown className="transform rotate-45" />
          ) : (
            <FaArrowUp className="transform rotate-45" />
          )}
        </div>

        <div className="flex flex-col">
          <h4 className="text-sm font-bold text-gray-900 capitalize">
            {isDeposit ? "Deposit" : "Withdrawal"}
          </h4>
          <span className="text-xs text-gray-500 flex items-center gap-1">
            {payment.createdAt &&
              format(new Date(payment.createdAt), "MMM dd, yyyy • h:mm a")}
          </span>
        </div>
      </div>

      {/* Right: Amount & Status */}
      <div className="text-right">
        <p
          className={`text-sm font-bold tabular-nums tracking-tight ${
            isDeposit ? "text-green-600" : "text-gray-900"
          }`}
        >
          {isDeposit ? "+" : "-"}
          <CurrencyDisplay usdAmount={payment.amount || 0} className="inline" />
        </p>

        <div
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide mt-1 ${getStatusColor(
            status,
          )}`}
        >
          {status === "completed" && <FaCheckCircle />}
          {status === "pending" && <FaClock />}
          {status === "failed" && <FaTimesCircle />}
          {payment.status || "Pending"}
        </div>
      </div>
    </div>
  );
};
